<template>
  <div id="adminContactos">
    <vue-headful title="Admin" lang="en" />
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-building"></i></div>
        </div>
        <input v-model="form.empresa" type="text" class="form-control" placeholder="Company" />
      </div>
    </div>
    <h4 class="h5 g-font-weight-600 g-mb-5 text-left">DEPARTMENT 1</h4>
    <div class="mb-2">
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-map"></i></div>
          </div>
          <textarea rows="3" v-model="form.morada" type="text" class="form-control" placeholder="Address"></textarea>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-phone"></i></div>
          </div>
          <input v-model="form.telefone" type="text" class="form-control" placeholder="Phone 1" />
        </div>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-phone"></i></div>
          </div>
          <input v-model="form.telefone1" type="text" class="form-control" placeholder="Phone 2" />
        </div>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-phone"></i></div>
          </div>
          <input v-model="form.telefone2" type="text" class="form-control" placeholder="Phone 3" />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-mobile"></i></div>
          </div>
          <input v-model="form.telemovel" type="text" class="form-control" placeholder="Mobile Phone 1" />
        </div>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-mobile"></i></div>
          </div>
          <input v-model="form.telemovel1" type="text" class="form-control" placeholder="Mobile Phone 2" />
        </div>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-mobile"></i></div>
          </div>
          <input v-model="form.telemovel2" type="text" class="form-control" placeholder="Mobile Phone 3" />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-envelope-square"></i></div>
          </div>
          <input v-model="form.email" type="text" class="form-control" placeholder="Email 1" />
        </div>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-envelope-square"></i></div>
          </div>
          <input v-model="form.email1" type="text" class="form-control" placeholder="Email 2" />
        </div>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-envelope-square"></i></div>
          </div>
          <input v-model="form.email2" type="text" class="form-control" placeholder="Email 3" />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-globe"></i></div>
          </div>
          <input v-model="form.site" type="text" class="form-control" placeholder="Website" />
        </div>
      </div>
    </div>
    <h4 class="h5 g-font-weight-600 g-mb-5 text-left">DEPARTMENT 2</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-map"></i></div>
        </div>
        <textarea rows="3" v-model="form.morada_dep2" type="text" class="form-control" placeholder="Address"></textarea>
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-phone"></i></div>
        </div>
        <input v-model="form.telefone_dep2" type="text" class="form-control" placeholder="Phone 1" />
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-phone"></i></div>
        </div>
        <input v-model="form.telefone1_dep2" type="text" class="form-control" placeholder="Phone 2" />
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-phone"></i></div>
        </div>
        <input v-model="form.telefone2_dep2" type="text" class="form-control" placeholder="Phone 3" />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-mobile"></i></div>
        </div>
        <input v-model="form.telemovel_dep2" type="text" class="form-control" placeholder="Mobile Phone 1" />
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-mobile"></i></div>
        </div>
        <input v-model="form.telemovel1_dep2" type="text" class="form-control" placeholder="Mobile Phone 2" />
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-mobile"></i></div>
        </div>
        <input v-model="form.telemovel2_dep2" type="text" class="form-control" placeholder="Mobile Phone 3" />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-envelope-square"></i></div>
        </div>
        <input v-model="form.email_dep2" type="text" class="form-control" placeholder="Email 1" />
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-envelope-square"></i></div>
        </div>
        <input v-model="form.email1_dep2" type="text" class="form-control" placeholder="Email 2" />
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-envelope-square"></i></div>
        </div>
        <input v-model="form.email2_dep2" type="text" class="form-control" placeholder="Email 3" />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-globe"></i></div>
        </div>
        <input v-model="form.site_dep2" type="text" class="form-control" placeholder="Website" />
      </div>
    </div>
    <h4 class="h5 g-font-weight-600 g-mb-5 text-left">MAPS</h4>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-map-marked-alt"></i></div>
        </div>
        <input v-model="form.latitude" type="text" class="form-control" id="linguas" aria-describedby="linguasHelp" placeholder="Latitude" />
        <input v-model="form.longitude" type="text" class="form-control" id="linguas" aria-describedby="linguasHelp" placeholder="Longitude" />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-map-marked-alt"></i></div>
        </div>
        <input v-model="form.linkMapa" type="text" class="form-control" placeholder="Iframe Google Maps" />
      </div>
    </div>
    <button type="button" @click="submit" class="btn btn-primary float-right">UPDATE</button>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'adminContactos',
  data () {
    return {
      form: {
        empresa: '',
        morada: '',
        telefone: '',
        telefone1: '',
        telefone2: '',
        telemovel: '',
        telemovel1: '',
        telemovel2: '',
        site: '',
        morada_dep2: '',
        telefone_dep2: '',
        telefone1_dep2: '',
        telefone2_dep2: '',
        telemovel_dep2: '',
        telemovel1_dep2: '',
        telemovel2_dep2: '',
        site_dep2: '',
        latitude: '',
        longitude: '',
        linkMapa: '',
        idGoogleAnalytics: '',
        idGoogleTagManager: ''
      }
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Contacts')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_LOAD1',
      'SET_TOAST',
      'SET_AVISO',
      'SET_OPTIONS'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.form = {
          empresa: this.$store.state.option.empresa || '',
          morada: this.$store.state.option.morada || '',
          telefone: this.$store.state.option.telefone || '',
          telefone1: this.$store.state.option.telefone1 || '',
          telefone2: this.$store.state.option.telefone2 || '',
          telemovel: this.$store.state.option.telemovel || '',
          telemovel1: this.$store.state.option.telemovel1 || '',
          telemovel2: this.$store.state.option.telemovel2 || '',
          email: this.$store.state.option.email || '',
          email1: this.$store.state.option.email1 || '',
          email2: this.$store.state.option.email2 || '',
          site: this.$store.state.option.site || '',
          morada_dep2: this.$store.state.option.morada_dep2 || '',
          telefone_dep2: this.$store.state.option.telefone_dep2 || '',
          telefone1_dep2: this.$store.state.option.telefone1_dep2 || '',
          telefone2_dep2: this.$store.state.option.telefone2_dep2 || '',
          telemovel_dep2: this.$store.state.option.telemovel_dep2 || '',
          telemovel1_dep2: this.$store.state.option.telemovel1_dep2 || '',
          telemovel2_dep2: this.$store.state.option.telemovel2_dep2 || '',
          email_dep2: this.$store.state.option.email_dep2 || '',
          email1_dep2: this.$store.state.option.email1_dep2 || '',
          email2_dep2: this.$store.state.option.email2_dep2 || '',
          site_dep2: this.$store.state.option.site_dep2 || '',
          latitude: this.$store.state.option.latitude || '',
          longitude: this.$store.state.option.longitude || '',
          linkMapa: this.$store.state.option.linkMapa
        }
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    submit () {
      this.SET_LOAD1(true)
      this.axios.post('/options', this.form).then((res) => {
        this.SET_TOAST({ msg: 'Updated successfully' })
        this.SET_OPTIONS(res.data)
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    }
  }
}
</script>
